import { Component, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent {
  @Output() navigateSection = new EventEmitter<string>();
  
  // Track toggle structural state for nested submenus
  menuDropdownOpen: boolean = false;

  constructor() {}

  onNavigate(sectionId: string): void {
    this.navigateSection.emit(sectionId);
  }

  toggleMenuDropdown(): void {
    this.menuDropdownOpen = !this.menuDropdownOpen;
  }
}
